import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import sharedMessages from "../../../shared-messages";
import { navigateToMyAccountPage } from "../../store/navigation/navigation";
import AcessDeniedError from "../access-denied-error";
import PageHeader from "../page-header";
import withPersonalization from "../with-personalization";
import PasswordUpdateForm from "./password-update-form";
import messages from "./password-update-messages";

import "./password-update.scss";

// eslint-disable-next-line prettier/prettier
const PasswordUpdate = ({ queryString, navigateToMyAccount, intl: { formatMessage }, isSso }) => {
  const myAccountPageUrl = `/user${queryString}`;
  const handleNavigateToMyAccountPageClick = () => {
    navigateToMyAccount(myAccountPageUrl);
  };
  return isSso ? (
    <AcessDeniedError />
  ) : (
    <main className="password-update">
      <PageHeader
        returnUrl={myAccountPageUrl}
        onReturnLinkClick={handleNavigateToMyAccountPageClick}
        isExternalLink={false}
        returnLinkText={formatMessage(sharedMessages.backToMyAccount)}
        pageTitleText={formatMessage(messages.changeMyPassword)}
      />
      <PasswordUpdateForm />
    </main>
  );
};

PasswordUpdate.propTypes = {
  navigateToMyAccount: PropTypes.func.isRequired,
  queryString: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  queryString: state.router.location.search
});

const mapDispatchToProps = {
  navigateToMyAccount: navigateToMyAccountPage
};

export { PasswordUpdate };
export default compose(
  withPersonalization,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(PasswordUpdate);
